document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('a[href*="#"]').forEach(function(anchor) {
    anchor.addEventListener("click", function(e) {
      const url = new URL(this.href);
      const hash = url.hash;

      if ((window.location.pathname === "/" || window.location.pathname === "/index") && hash) {
        e.preventDefault();
        const target = document.querySelector(hash);
        if (target) {
          const offset = 80; // header height
          const elementPosition = target.offsetTop - offset;
          window.scrollTo({
            top: elementPosition,
            behavior: "smooth"
          });
        }
      }
    });
  });
});
